import Cookies from 'js-cookie'
import PropsTypes from 'prop-types'
import { useState } from 'react'
import { Col, Modal, Row, Spinner } from 'react-bootstrap'
import config from '../../../../config'
import FindUserCard from './FindUserCard'
import UserDetailCard from './UserDetailCard'
import UploadImage from './UploadImage'
import Swal from 'sweetalert2'

export const KYCManualModal = ({ isOpen, onDataCreated, onClose }) => {
  const [loading, setLoading] = useState(false)
  const [userData, setUserData] = useState(null)
  const [imageData, setImageData] = useState({
    idCard: '',
    bankAccount: '',
  })

  const handleSubmit = () => {
    if (!userData?.id || !imageData.idCard || !imageData.bankAccount) return

    const body = {
      userId: userData.id,
      cardInfo: {
        fileId: imageData.idCard,
      },
      bookBankInfo: {
        fileId: imageData.bankAccount,
      },
    }

    setLoading(true)

    fetch(`${config.apiAdminGateway}/api/v1/admin/kyc`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.status.code !== 0) throw new Error(response.status.code)

        onDataCreated(response.data.id)
      })
      .catch((error) => {
        console.error(error)
        let message = 'กรุณาลองใหม่อีกครั้ง'

        if (error.message === '120202') {
          message = 'มีข้อมูลการยืนยันตัวตนอยู่แล้ว'
        } else if (error.message === '120203') {
          message = 'ผู้ใช้ยืนยันตัวตนสำเร็จไปแล้ว'
        }

        Swal.fire('ไม่สามารถยืนยันตัวตนได้', message)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleCloseModal = () => {
    if (loading) return
    setUserData(null)
    setImageData({
      idCard: '',
      bankAccount: '',
    })
    onClose()
  }

  return (
    <Modal
      className="fade"
      size="lg"
      show={isOpen}
      scrollable
      centered
      enforceFocus={false}
      onEscapeKeyDown={handleCloseModal}
      onHide={handleCloseModal}
    >
      <Modal.Header closeButton>
        <Row style={{ width: '100%' }}>
          <Col xs={10}>
            <Modal.Title>{userData?.id ? `รหัสลูกค้า: ${userData.userId}` : 'ยืนยันตัวตนใหม่'}</Modal.Title>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body style={{ position: 'relative' }}>
        <Row>
          <Col xs={12}>
            {!userData ? (
              <FindUserCard onUserFound={(user) => setUserData(user)} />
            ) : (
              <UserDetailCard userData={userData} />
            )}
          </Col>
          <Col xs={12}>
            {userData && (
              <div>
                <UploadImage
                  inputId="idCard"
                  userId={userData.id}
                  title="รูปบัตรประชาชน"
                  onUploadImage={(id) => setImageData((prev) => ({ ...prev, idCard: id }))}
                  onRemoveImage={() => setImageData((prev) => ({ ...prev, idCard: '' }))}
                />
                <hr />
                <UploadImage
                  inputId="bankAccount"
                  userId={userData.id}
                  title="รูปหน้าสมุดบัญชีธนาคาร"
                  onUploadImage={(id) => setImageData((prev) => ({ ...prev, bankAccount: id }))}
                  onRemoveImage={() => setImageData((prev) => ({ ...prev, bankAccount: '' }))}
                />
              </div>
            )}
          </Col>
        </Row>
        {loading && (
          <div
            style={{
              textAlign: 'center',
              position: 'absolute',
              inset: 0,
              backgroundColor: 'rgba(0,0,0,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Spinner animation="border" role="status" style={{ width: '64px', height: '64px' }}>
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-primary"
          disabled={!userData || !imageData.idCard || !imageData.bankAccount}
          onClick={handleSubmit}
        >
          ยืนยัน
        </button>
        <button className="btn" disabled={loading} onClick={handleCloseModal}>
          ยกเลิก
        </button>
      </Modal.Footer>
    </Modal>
  )
}

KYCManualModal.propTypes = {
  isOpen: PropsTypes.bool.isRequired,
  onClose: PropsTypes.func.isRequired,
}

export default KYCManualModal
